// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { root as _root } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the root chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 7668
 * Chain Name: The Root Network
 * Default Block Explorer: https://rootscan.io
 * Default RPC URL: https://root.rootnet.live/archive
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { root } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: root,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const root = createCommon({
	..._root,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
